import React, { useState } from "react";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Peut être synchrone ou retourner une Promise ; le bouton reste désactivé jusqu'à la fin. */
  onConfirm: () => void | Promise<unknown>;
  title: string;
  message: string;
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}: ConfirmationModalProps) {
  const [pending, setPending] = useState(false);

  const handleConfirm = async () => {
    if (pending) return;
    setPending(true);
    try {
      const result = onConfirm();
      if (result instanceof Promise) await result;
    } catch (err) {
      console.error("Erreur action confirmation:", err);
    } finally {
      setPending(false);
    }
  };

  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60] animate-in fade-in"
      onClick={pending ? undefined : onClose}
      role="presentation"
    >
      <div
        className="bg-white dark:bg-slate-800 dark:backdrop-blur-xl border border-gray-200 dark:border-white/10 rounded-2xl shadow-2xl p-6 max-w-sm w-full animate-in zoom-in-95"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">{title}</h3>
        <p className="text-gray-600 dark:text-slate-300 mb-6">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={pending}
            className="px-4 py-2 text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-xl transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Annuler
          </button>
          <button
            onClick={handleConfirm}
            disabled={pending}
            className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl shadow-lg shadow-blue-500/30 hover:opacity-95 transition-opacity font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {pending ? "En cours…" : "Confirmer"}
          </button>
        </div>
      </div>
    </div>
  );
}
